module.exports = __webpack_public_path__ + "manual-save.png?d998162d4fcba219dee5f8818b729c3c";


//////////////////
// WEBPACK FOOTER
// ./src/images/manual-save.png
// module id = 403
// module chunks = 0